// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const uploadMediaSuccess = (ui, name, media) => {
  return {
    type: constants.UPLOAD_MEDIA_SUCCESS,
    ui,
    name,
    media,
  };
};

const uploadMediaError = (error) => {
  return {
    type: constants.UPLOAD_MEDIA_ERROR,
    error,
  };
};

const uploadMedia = (mediaFor, mediaType, file) => {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('mediaFor', mediaFor.s3FolderName);
      formData.append('mediaType', mediaType);
      let apiURL = `${experienceAPIURL}/medias/upload`;
      const config = {
        url: apiURL,
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        data: formData,
      };

      acHTTPClient
        .request(config)
        .then((response) => {
          if (!response.data || response.data.error) {
            dispatch(uploadMediaError(response.statusText));
          }

          dispatch(uploadMediaSuccess(mediaFor.ui, mediaFor.name, response.data.data));
        })
        .catch((error) => {
          onAuthError(error);
          dispatch(uploadMediaError(error));
        });
    } catch (error) {
      onAuthError(error);
      let errObj = error;
      if (typeof errObj === 'string') {
        errObj = new Error(errObj);
      }
      return dispatch(uploadMediaError(errObj));
    }
  };
};

export { uploadMedia };
